import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Home from './components/pages/Home';
import Login from './components/pages/Login';
import Partners from './components/pages/Partners';
import Customers from './components/pages/Customers';
import Devices from './components/pages/Devices'
import Patients from './components/pages/Patient'
import Sessions from './components/pages/Sessions'
import VitalsBoard from './components/pages/VitalsBoard';
import Logout from './components/pages/Logout';
import NotFoundPage from './components/pages/NotFoundPage';
import ErrorBoundary from './components/pages/ErrorBoundary';
import EditCustomerPage from './components/pages/EditCustomerPage';
import AuthCallback from './components/molecules/AuthCallback';
import Vitals from './components/pages/Vitals';
import { PimsPage } from './components/pages/PIMS';
import OrganizationSetupPage from './components/pages/OrganizationSetupPage';
import DeviceConnection from './components/pages/DeviceConnection';
import EditDevicePage from './components/pages/EditDevicePage';
import AccountPage from './components/pages/Account';
import PasswordReset from './components/pages/PasswordReset';

const AppRoutes: React.FC = () => {
  const location = useLocation();
  const isVitalsBoard = location.pathname === '/vitalsboard';

  return (
    <ErrorBoundary>
      <Container fluid={isVitalsBoard}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/authcallback" element={<AuthCallback />} />
          <Route path="/organization-setup" element={<OrganizationSetupPage />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/edit-customer/:id" element={<EditCustomerPage />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/connect" element={<DeviceConnection />} />
          <Route path="/devices/edit/:id" element={<EditDevicePage />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/vitals/:deviceId" element={<Vitals />} />
          <Route path="/vitalsboard" element={<VitalsBoard />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/settings/pims" element={<PimsPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/" element={<Home />} />
          <Route element={<NotFoundPage />} />
        </Routes>
      </Container>
    </ErrorBoundary>
  );
};

export default AppRoutes;
